import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { persistor, store } from 'src/store/store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './components/AuthProvider/authProvider';
import { BASE_PATH } from 'src/config';
import { PersistGate } from 'redux-persist/integration/react';

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  // <React.StrictMode>
  <AuthProvider>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter basename={BASE_PATH}>
          <App />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </AuthProvider>
  // </React.StrictMode>
);

reportWebVitals();
